import React from "react";
import { Icon } from "@mdi/react";
import { mdiLoading } from "@mdi/js";

export function Spinner() {
  return <Icon path={mdiLoading} size={3} spin={2} />;
}
